// extracted by mini-css-extract-plugin
export default {"CampaignFlowHeading":"CampaignFlow_CampaignFlowHeading__tv8JJ"};